import NoteDetail from './NoteDetail/NoteDetail.store';
import NotesLanding from './NotesLanding/NotesLanding.store';

const state = {
  isGeneratingPdf: false,
};

const mutations = {
  setIsGeneratingPdf(state, isGeneratingPdf) {
    state.isGeneratingPdf = isGeneratingPdf;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  modules: {
    NoteDetail,
    NotesLanding,
  },
};
